import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'input[type="date"]'
})
export class DisableDateKeyboardDirective {
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    console.log(1);
    event.preventDefault();
  }
}
